import { Item } from 'src/types';

const NO_REBUILD_FIELDS: (keyof Item)[] = [
  'key',
  'xMin',
  'xMax',
  'yMin',
  'yMax',
  'reviewerName',
  'cratingDimensions',
  'externalNotes',
  'annotationSource',
  'shipment',

  'isoCode1',
  'isoCode2',
  'isoCode3',
  'isBulky',
  'isProGear',
  'isValuable',
  'is3rdPartyServicing',
  'isSpecialEquipment',
  'isAssembleDisassemble',
  'isShipperConfirmed',
  // There is no functionality on the frontend to move items between images of different rooms/videos.
  // No need to rebuild inventory on image change.
  'imageKey',
  'surveyType',
  'imageSource',
];

export const isTotalsRebuildRequired = (tagsToUpdate: Partial<Item>[]) =>
  tagsToUpdate.some((item) => {
    for (const field in item) {
      if (!NO_REBUILD_FIELDS.includes(field as keyof Item)) {
        return true;
      }
    }

    return false;
  });
